import type { JSX } from 'react'

import { AuthFormBoxTrueIdTemplate } from "/app/libraries/arcana/src/blocks/AuthFormBox/Templates/index.ts"
import { TextBoxMaxLine1Headline2 } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"
import { TrueIdLoginButton } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"

import { useUnit } from 'effector-react'
import {
  signInByTrueIdFeatureModel,
  model as signInModel,
} from '~/features/subscriber/sign-in'
import { useErrorMessage } from '~/widgets/Popups/MessagePortal'
import { $signInTrueIdFormTranslations } from './i18n'

export const SignInTrueIdForm = (): JSX.Element => {
  const formTranslations = useUnit($signInTrueIdFormTranslations)
  const message = useUnit(signInModel.$trueIdmessage)

  const trueIdSignInFx = useUnit(signInByTrueIdFeatureModel.trueIdSignInFx)

  const pendingTrueId = useUnit(
    signInByTrueIdFeatureModel.trueIdSignInFx.pending
  )
  const pendingSignin = useUnit(signInModel.signInFx.pending)
  const pending = pendingTrueId || pendingSignin

  const onTrueIdSignInFx = () => {
    trueIdSignInFx()
  }

  useErrorMessage(message, 'SignInTrueIdForm')

  return (
    <AuthFormBoxTrueIdTemplate>
      <TextBoxMaxLine1Headline2 title={formTranslations.title} />

      <TrueIdLoginButton
        withLoader
        isLoading={pending}
        disabled={pending}
        onClick={onTrueIdSignInFx}
      />
    </AuthFormBoxTrueIdTemplate>
  )
}
